import {Dialog, type DialogButtonProps, type DialogProps} from '@primer/react'
import {useCallback} from 'react'

import styles from './alert-dialog.module.css'

export interface AlertDialogProps {
  title: React.ReactNode
  confirmButtonContent?: React.ReactNode

  /**
   * Required. This callback is invoked when a gesture to close the dialog
   * is performed. The first argument indicates the gesture.
   */
  onClose: (gesture: 'confirm' | 'close-button' | 'escape') => void
  children?: React.ReactNode
}

export const SingleConfirmBody: React.FC<DialogProps & {children?: React.ReactNode}> = ({children}) => {
  return <div className={styles.Box}>{children}</div>
}

const SingleConfirmFooter: React.FC<DialogProps> = ({footerButtons}) => (
  <div className={styles.Box_1}>
    <Dialog.Buttons buttons={footerButtons ?? []} />
  </div>
)

export const AlertDialog: React.FC<AlertDialogProps> = ({children, confirmButtonContent = 'OK', onClose, title}) => {
  const onConfirmButtonClick = useCallback(() => {
    onClose('confirm')
  }, [onClose])

  const confirmButton: DialogButtonProps = {
    buttonType: 'primary',
    content: confirmButtonContent,
    onClick: onConfirmButtonClick,
  }

  return (
    <Dialog
      title={title}
      role="alertdialog"
      width="medium"
      onClose={onClose}
      footerButtons={[confirmButton]}
      renderBody={SingleConfirmBody}
      renderFooter={SingleConfirmFooter}
    >
      {children}
    </Dialog>
  )
}
